import React, {useState, useEffect} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';

import {Itoy} from './utils/abstraction';

import {Home} from './components/home/Home';
import {StorePage} from './components/store/StorePage';
import {TreePage} from './components/tree/TreePage';
import {Footer} from './components/footer/Footer';
import {Modal} from './components/modal/Modal';

import './app.sass';
import { Header } from './components/header/Header';
// import { createBrowserHistory } from 'history';

// @ts-ignore
import url from './assets/audio/audio.mp3';

const App = () => {
  const [favoriteToys, setFavoriteToys] = useState<Itoy[]>([]);
  const [activeModal, setAtiveModal] = useState(false);

  const toggleFavoriteToy = (idToy: Itoy): boolean => {
    const index = favoriteToys.find((toy) => toy.num === idToy.num);

    if (index) {
      if (favoriteToys.length === 20) {
        setAtiveModal(true);
        return false;
      }
      const newToys = favoriteToys.filter((toy) => toy.num !== idToy.num)
      setFavoriteToys(newToys);
      localStorage.setItem("chromari-favoriteToys", JSON.stringify(newToys));
      return false;
    } else {
      setFavoriteToys([...favoriteToys, idToy]);
      localStorage.setItem("chromari-favoriteToys", JSON.stringify([...favoriteToys, idToy]));
      return true;
    }
  };

  // const history = createBrowserHistory();

  // useEffect(() => localStorage.setItem("chromari-favoriteToys", JSON.stringify(favoriteToys)), [favoriteToys]);
  useEffect(() => {
    const date = localStorage.getItem("chromari-favoriteToys");
    if (date) setFavoriteToys(JSON.parse(date));
  }, []);

  const closeModal = () => {
    setAtiveModal(false);
  }

  console.log(`Итог: 200/200
    [+] - Вёрстка страниц приложения и навигация между ними +30/30:
      [+] - стартовая страница содержит название приложения и кнопку "Начать игру" или аналогичную. Выполняются требования к вёрстке +10;
      [+] - на странице с ёлкой есть меню с настройками, слоты с добавленными в избранное игрушками, ёлка. Выполняются требования к вёрстке +10;
      [+] - в header приложения есть навигация, которая позволяет с каждой страницы приложения перейти на две другие страницы +10.
    ----
    
    [+] - Меню с настройками +50/50:
      [+] - выбрать один из нескольких (минимум 8) фонов +10;
      [+] - выбрать одну из нескольких (минимум 4) ёлок +10;
      [+] - включить/отключить падающий снег +10;
      [+] - включить/отключить новогоднюю музыку +10;
      [+] - выбранные настройки сохраняются в local storage и отображаются при перезагрузке страницы. Если музыка сохранилась включённой, она начинает играть при первом клике. Есть кнопка сброса настроек, которая очищает local storage +10.
    ----
    
    [+] - Гирлянда +40/40:
      [+] - добавить на ёлку мерцающую разноцветную гирлянду +20;
      [+] - выбрать один из нескольких (минимум 4) цветов лампочек гирлянды или оставить её разноцветной +10;
      [+] - внешний вид гирлянды соответствует предложенному образцу или является его улучшенной версией +10.
    ----
    
    [+] - Игрушки в избранном +80/80:
      [+] - в слотах находятся игрушки, которые были добавлены в избранное на странице с игрушками +10;
      [+] - если в избранное не была добавлена ни одна игрушка, в слотах отображаются первые 20 игрушек коллекции исходных данных +10;
      [+] - игрушки из слотов с игрушками можно перетянуть на ёлку используя drag and drop +10;
      [+] - если в процессе перетягивания игрушку отпускают за пределами ёлки, она возвращается в свой слот +10;
      [+] - повешенные на ёлку игрушки можно перетягивать в пределах ёлки +10;
      [+] - повешенные на ёлку игрушки можно снимать с ёлки, при этом они возвращаются в свой слот +10;
      [+] - возле слота с каждой игрушкой указывается количество игрушек в слоте равное количеству экземпляров игрушки в массиве с исходными данными +10;
      [+] - когда игрушку "вешают на ёлку" количество игрушек в слоте уменьшается, когда игрушку "снимают с ёлки", количество игрушек в слоте увеличивается, когда все экземпляры игрушки помещаются на ёлку, отображается пустой слот +10.
  `);

  const [audio, setAudio] = useState(new Audio(url));

  return (
    <div className="app">
      {activeModal && <Modal closeModal={closeModal}/>}
      <BrowserRouter>
        <Header countFavorite={favoriteToys.length}/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/shop-toys' element={<StorePage func={toggleFavoriteToy}/>}/>
          <Route path='/tree' element={<TreePage toys={favoriteToys} audio={audio}/>}/>
        </Routes>
      </BrowserRouter>
      <Footer/>
    </div>
  );
}

export default App;
